import React from 'react';

// The app has no error boundary anywhere, so any uncaught render error
// (e.g. a token record with an unexpected field shape) unmounts the whole
// React tree. Since index.css/App.css set `body { background: rgba(4, 10, 8, 0.72) }`,
// that unmount looks like the page "going blank black" — there's nothing
// wrong with the CSS, it's just what's left once React gives up.
//
// Wrap risky, self-contained pieces of UI (like the token edit dialogs) in
// this boundary so a bad record shows a recoverable error instead of
// nuking the whole page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) this.props.onReset();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.handleReset);
      }
      return (
        <div
          style={{
            backgroundColor: 'whitesmoke',
            color: '#111',
            padding: '2rem',
            borderRadius: '8px',
            maxWidth: 500,
            margin: '10vh auto',
            textAlign: 'center'
          }}
        >
          <h3 style={{ marginTop: 0 }}>Something went wrong</h3>
          <p style={{ fontSize: '14px', color: '#555' }}>
            This form hit an unexpected error and couldn't render. Your data
            wasn't changed.
          </p>
          <button
            onClick={this.handleReset}
            style={{
              backgroundColor: 'darkgreen',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Close
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
